<script>

export default {
    props: ["message"],
    data() {
        return {
            formData: {
                full_name: '',
                contact_info: '',
                accused_person: '',
                content: '',
                files: []
            },
            submitted: false,
            success: false,
            processing: false,
            validFileSize: true,
            fileErrMsg: 'File size exceeds the maximum limit.',
            dragOver: false,
            recaptchaSiteKey: ''
        };
    },
    mounted() {
        this.recaptchaSiteKey = document.getElementById('recaptchaSiteKey').value;
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render='+this.recaptchaSiteKey;
        document.head.appendChild(script);
    },
    methods: {
        removeFile(index) {
            this.formData.files.splice(index, 1);
            console.log(this.formData.files);
        },
        handleFileUpload(event) {
            const selectedFiles = Array.from(event.target.files);
            this.processFiles(selectedFiles);
        },
        processFiles(files) {
            // Filter out duplicate files
            const uniqueFiles = files.filter(file => {
                return !this.formData.files.some(existingFile => 
                    existingFile.name === file.name && existingFile.size === file.size);
            });

            const totalSize = uniqueFiles.reduce((sum, file) => sum + file.size, 0) + this.formData.files.reduce((sum, file) => sum + file.size, 0);

            if (totalSize > 25 * 1024 * 1024) {
                console.log('Total file size exceeds the 25 limit.');
                this.validFileSize = false;
                return;
            }

            this.validFileSize = true;

            // Append new files to the existing files in formData
            this.formData.files = [...this.formData.files, ...uniqueFiles];
        },
        // Handle drag and drop
        handleDrop(event) {
            event.preventDefault();
            event.stopPropagation();
            this.dragOver = false;
            const droppedFiles = Array.from(event.dataTransfer.files);
            this.processFiles(droppedFiles);
        },
        handleDragOver(event) {
            event.preventDefault();
            event.stopPropagation();
            this.dragOver = true;
        },
        handleDragLeave(event) {
            event.preventDefault();
            event.stopPropagation();
            this.dragOver = false;
        },
        validateFields() {
            let isValid = true;
            
            // Check each field in formData except files
            for (const key in this.formData) {
                if (key !== 'files') {
                    if (this.formData[key] === '') {
                        isValid = false;
                    }
                }
            }
            return isValid;
        },
        onSubmit() {
            this.submitted = true;
            const isValid = this.validateFields() && this.validFileSize;
            if (isValid) {
                this.processing = true;
                
                // Request reCAPTCHA v3 token
                grecaptcha.ready(() => {
                    grecaptcha.execute(this.recaptchaSiteKey, {action: 'submit'}).then((token) => {
                        const formData = new FormData();
                        for (const key in this.formData) {
                            if (key === 'files') {
                                for (let i = 0; i < this.formData[key].length; i++) {
                                    formData.append('files[]', this.formData[key][i]);
                                }
                            } else {
                                formData.append(key, this.formData[key]);
                            }
                        }
                        // Add reCAPTCHA token
                        formData.append('g-recaptcha-response', token);

                        axios.post('/wp-json/chc-wp-theme/v1/request-whistleblowing', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        })
                        .then(response => {
                            console.log('Response:', response.data);
                            if (response.data.success) {
                                this.success = true;
                                this.processing = false;
                                window.scrollTo(0,0);
                            }
                        })
                        .catch(error => {
                            console.error('Error:', error);
                            this.processing = false;
                        });
                    });
                });
            }
        }
    }
};
</script>
